// Хосты, на которые разрешён внешний редирект после регистрации
const ALLOWED_ORIGINS = [
  process.env.VUE_APP_URSULA_URL,
  "http://localhost:3575", // дев-хост урсулы
];

export function isAllowedExternalNext(url) {
  if (!url?.startsWith("http")) return false;
  try {
    const origin = new URL(url).origin;
    return ALLOWED_ORIGINS.filter(Boolean).some(
      (n) => new URL(n).origin === origin
    );
  } catch {
    return false;
  }
}
